export default class StringUtil {
	/**
	 * 文字列がNullまたは空文字であるかどうかを判定する。
	 * ※同様のことは`if(value)`の様にチェックできるが、ReviCoのJSコーディング規約上厳密に判定を行う。
	 * @param value 判定対象の文字列
	 */
	public static isNullOrEmpty(value: string | undefined | null): boolean {
		return value === null || value === undefined || value === "";
	}
}
